import { AutogenLayoutEdiTenderProfileQuickInfo } from "./autogen/AutogenLayoutEdiTenderProfileQuickInfo";

export class EdiTenderProfileQuickInfo extends AutogenLayoutEdiTenderProfileQuickInfo {

}
